module.exports = __webpack_public_path__ + "img/13.d373ee92.svg";